import * as React from "react";
import { useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import DynamicForm from "../../../../../../../core/presentations/DynamicForm";
import Validators from "../../../../../../../ui/helpers/validators";
import { OptionsConstants } from "../../../../../../../ui/models/constants/options.constants";
import TopLabelFieldTemplate from "../../../../../../../ui/templates/fields/TopLabelFieldTemplate";
import VerticalFormTemplate from "../../../../../../../ui/templates/objects/VerticalFormTemplate";
import PrwcBasicButton from "../../../../../../../ui/widgets/custom/buttons/PrwcBasicButton";
import BusinessHours from "../BusinessHours";
import "./Workflow.scss";

const Workflow = (props: any) => {
  const { data } = props;
  const { t } = useTranslation();
  const submitButtonRef: any = useRef(null);
  const [formData, setFormData] = useState(data);

  const onChange = (data: any) => {
    setFormData(data);
  };

  const onSubmit = (data: any) => {
    console.log("data submitted ---");
    console.log(data);
  };

  const onError = (data: any) => {
    console.log("on error ---");
    console.log(data);
  };

  const handleOnSubmit = () => {
    // It is to submit form programmatically.
    submitButtonRef.current.click();
  };

  const formButtons = () => {
    return (
      <button ref={submitButtonRef} type="submit" className="hidden p-col-12" />
    );
  };

  const schema: any = {
    title: t("userCategories.label.general"),
    type: "object",
    properties: {
      workflowName: {
        type: "string",
        title: t("userCategories.label.workflowName"),
      },
      parentWorkflow: {
        type: "number",
        title: t("userCategories.label.parentWorkflow"),
      },
      abbreviation: {
        type: "string",
        title: t("userCategories.label.abbreviation"),
      },
      description: {
        type: "string",
        title: t("userCategories.label.description"),
      },
      timeZone: {
        type: "string",
        title: t("userCategories.label.timeZone"),
      },
    },
    required: ["workflowName", "abbreviation"],
  };

  const validationSchema: any = {
    workflowName: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "userCategories.validation.workflow.workflowNameRequired",
        },
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 25);
          },
          messageKey:
            "userCategories.validation.workflow.workflowNameMaxLength",
        },
      ],
    },
    abbreviation: {
      validators: [
        {
          validate: (value: string) => {
            return !Validators.isStringEmpty(value);
          },
          messageKey: "userCategories.validation.workflow.abbreviationRequired",
        },
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 25);
          },
          messageKey:
            "userCategories.validation.workflow.abbreviationMaxLength",
        },
      ],
    },
    description: {
      validators: [
        {
          validate: (value: string) => {
            return Validators.isMaxLengthValid(value, 100);
          },
          messageKey: "userCategories.validation.workflow.descriptionMaxLength",
        },
      ],
    },
  };

  const uiSchema: any = {
    "ui:ObjectFieldTemplate": VerticalFormTemplate,
    workflowName: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    parentWorkflow: {
      "ui:widget": "prwDropdownBasic",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:options": {
        showClear: true,
      },
    },
    abbreviation: {
      "ui:widget": "prwInputText",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    description: {
      "ui:widget": "prwInputTextArea",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:emptyValue": "",
    },
    timeZone: {
      "ui:widget": "prwDropdownBasic",
      "ui:FieldTemplate": TopLabelFieldTemplate,
      classNames: "p-col-12",
      "ui:options": {
        dropdownOptions: OptionsConstants.TimeZones,
        showClear: true,
        filter: true,
      },
    },
  };

  return (
    <div className="workflow">
      <div className="px-4 overflow-y-auto content-height">
        <div>
          <DynamicForm
            onChange={onChange}
            formData={formData}
            onSubmit={onSubmit}
            onError={onError}
            schema={schema}
            uiSchema={uiSchema}
            validationSchema={validationSchema}
            formButtons={() => formButtons()}
          ></DynamicForm>
        </div>

        <div className="mt-4">
          <div className="font-semibold">
            {t("userCategories.label.businessHours")}
          </div>
          <div className="mt-2">
            <BusinessHours></BusinessHours>
          </div>
        </div>
      </div>
      <div className="flex justify-end px-2 border-t">
        <PrwcBasicButton
          onClick={handleOnSubmit}
          labelKey="users.action.save"
          className="w-24 h-8 my-1 bg-blue-700 border-blue-700 p-button-sm"
        ></PrwcBasicButton>
      </div>
    </div>
  );
};

export default Workflow;
